import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import {
  IconButton, Modal, ModalBody, ModalHeader,
} from '@americanexpress/dls-react';
import { IconInfo } from '@americanexpress/dls-icons';
import { useSelector } from 'react-redux';
import { BUNDLE_TYPES } from '../../constants/packagesConstants';
import { getBundleType } from '../../selectors/filtersSelectors';

const RoomsTravelersInfoModal = () => {
  const { formatMessage } = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => { setIsOpen(true); };
  const closeModal = () => { setIsOpen(false); };
  const bundleType = useSelector(getBundleType);

  return (
    <>
      <IconButton
        screenReaderLabel={formatMessage({ id: 'filterTooltip.ariaLabel' })}
        shape="round"
        variant="tertiary"
        id="searchPackagesNumTravelersModalButton"
        onClick={openModal}
        reactlytics={{ element: 'packages_travelers' }}
      >
        <IconInfo style={{ width: '1rem' }} />
      </IconButton>
      {
        isOpen && (
          <Modal
            id="packagesTravelerModal"
            aria-labelledby="searchPackagesNumTravelersModalButton"
            onClose={closeModal}
          >
            <ModalHeader>
              <h2>{formatMessage({ id: 'modal.travelers' })}</h2>
            </ModalHeader>
            <ModalBody style={{ maxWidth: '50rem' }}>
              <h3>{formatMessage({ id: 'modal.adult' })}</h3>
              {formatMessage({ id: 'modal.adult_age_range' })}
              <h3 className="margin-2-t">{formatMessage({ id: 'modal.child' })}</h3>
              {formatMessage({ id: 'modal.child_age_range' })}
              <br />
              {formatMessage({ id: 'modal.must_be_one_adult' })}
              <h3 className="margin-2-t">{formatMessage({ id: 'modal.infant' })}</h3>
              {formatMessage({ id: 'modal.ages_colon_younger_than_2' })}
              <br />
              {formatMessage({ id: 'modal.fare_lap_or_seat' })}
              <section>{formatMessage({ id: 'modal.note_maximum_travelers' })}</section>
              {bundleType !== BUNDLE_TYPES.AIR_CAR && (
                <>
                  <br className="margin-2-t" data-testid="additional-note" />
                  {formatMessage({ id: 'modal.additional_note' })}
                </>
              )}
            </ModalBody>
          </Modal>
        )
      }
    </>
  );
};

export default RoomsTravelersInfoModal;
